import React, {Fragment} from 'react';
import Button from "../../../Button";
import {DeserializedElement, DeserializedElementRule} from "../../slate/Transformation";
import {Editor, Element as SlateElement, Node, Transforms} from "slate";

const toolbarButton = ({editor, isActive, disabled}: {editor?: Editor, isActive?: boolean, disabled?: boolean}) => {
    let node: Node;
    if (isActive) {
        const [match] = Editor.nodes(editor, {
            match: n => n.type === 'blockquote'
        });
        node = match?.[0];
    }
    return <Button
        onClick={(e) => {
            e && e.preventDefault();
            if (!node) {
                Transforms.setNodes(
                    editor,
                    {type: 'blockquote'},
                    {
                        match: n =>
                            !Editor.isEditor(n) &&
                            SlateElement.isElement(n) &&
                            n.type === 'p'
                    });
            } else {
                Transforms.setNodes(editor, {type: 'p'}, {
                    match: n =>
                        !Editor.isEditor(n) &&
                        SlateElement.isElement(n) &&
                        n.type === 'blockquote'
                });
            }
        }}
        icon="format_quote"
        color={!!node ? "primary" : "default"}
        tooltip="Idézet"
        disabled={disabled}
    />
};

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "blockquote": {
        isVoid: () => false,
        tagType: () => 'block',
        match: (element) => element.type === 'blockquote',
        isActive: (editor) => {
            const [component] = Editor.nodes(editor, {
                match: n =>
                    !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'blockquote',
            })
            return !!component
        },
        toolbarButton,
        deserialize(el, next) {
            const name = el.tagName?.toLowerCase();
            if (name === 'blockquote') {
                return {
                    type: name,
                    props: {},
                    children: next(el.childNodes)
                } as DeserializedElement;
            }
        },
        serialize(node, next) {
            if (node.type === 'blockquote') {
                return <node.type>{next(node.children)}</node.type>;
            }
        },
        render: ({node}) => {
            return (node.element.type === 'blockquote' ? <node.element.type {...node.attributes}>{node.children}</node.element.type> : undefined);
        }
    }
}